import styled from 'styled-components'

import { TITLE_PROPS, BALANCE_PROPS, MENU_PROPS } from './interfaces'

export const Container = styled.header`
  display: flex;
  width: 100%;
  height: 36px;
  align-items: center;
  min-width: 315px;
`

export const Title = styled.h1<TITLE_PROPS>`
  text-transform: uppercase;
  line-height: 1.1;
  font-size: ${({ fontSize }) => fontSize || '26px'};
  letter-spacing: ${({ letterSpace }) => letterSpace || 'unset'};
  color: ${({ textColor }) => textColor};
`

export const Balance = styled.div<BALANCE_PROPS>`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  font-size: 14px;
  color: ${({ textColor }) => textColor};
  flex-wrap: wrap;
  overflow: hidden;
  margin: 0 5px;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 5px;
  }
  span {
    display: flex;
    align-items: center;
    svg {
      width: 14px;
      height: 13px;
      transform: translateY(1px);
      path {
        fill: ${({ textColor }) => textColor};
      }
    }
  }
`

export const Menu = styled.div<MENU_PROPS>`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  background: ${({ background }) => background};
  width: 32px;
  height: 32px;
  transform: ${p => (p.btnClick ? 'scale(0.65)' : 'scale(1)')};
  transition: transform 0.167s;
  transition-timing-function: cubic-bezier(0.33, 0, 0, 1);
  svg {
    path {
      fill: ${({ textColor }) => textColor};
    }
  }
`
